module.exports = __webpack_public_path__ + "media/images/writer/monitor/ico-monitor-aaadbd7be362329518238c3cdf5445e2.svg";